import React from "react";
import MarkdownRenderer from "../../MarkdownRenderer";

type OrchestratorAgentProps = {
    parsedContent: any;
};

export default function OrchestratorAgent({ parsedContent }: OrchestratorAgentProps): JSX.Element {
    return (
        <div>
            <MarkdownRenderer content={parsedContent?.finalAnswer?.answer?.toString()} />
        </div>
    );
}
